import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  const guideLinks = [
    { label: 'Shopping Guide', to: '/shopping-guide' },
    { label: 'What Is Mulebuy Spreadsheet', to: '/what-is-mulebuy-spreadsheet' },
    { label: 'Best Spreadsheet Lists', to: '/best-mulebuy-spreadsheets' },
    { label: 'Compare Agents', to: '/mulebuy-agents-comparison' },
    { label: 'Safety Guide', to: '/is-mulebuy-spreadsheet-safe' },
  ];

  const blogLinks = [
    { label: 'Beginner Guide 2026', to: '/blog/mulebuy-spreadsheet-guide-2026' },
    { label: 'Spreadsheet vs Agent', to: '/blog/mulebuy-spreadsheet-vs-agent' },
    { label: 'How to Use Spreadsheet', to: '/blog/how-to-use-mulebuy-spreadsheet' },
    { label: 'Spreadsheet Benefits', to: '/blog/mulebuy-spreadsheet-benefits' },
    { label: 'Pricing & Cost Guide', to: '/blog/mulebuy-spreadsheet-pricing' },
  ];

  return (
    <footer className="relative w-full bg-secondary-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="bg-white rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
                  Mulebuy<span className="text-primary-500">Spreadsheet</span>
                </span>
              </Link>
              <p className="text-xs text-foreground-500 mt-3 leading-relaxed max-w-xs">
                mulebuyspreadsheets.living — Your trusted hub for mulebuy spreadsheet lists, agent comparisons, and updated buying data. Helping buyers find reliable sourcing information since 2026.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4 whitespace-nowrap">
                Categories
              </h4>
              <ul className="space-y-2">
                {col1.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4 whitespace-nowrap">
                More Categories
              </h4>
              <ul className="space-y-2">
                {col2.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4 whitespace-nowrap">
                SEO Guides
              </h4>
              <ul className="space-y-2">
                {guideLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4 whitespace-nowrap">
                Blog &amp; More
              </h4>
              <ul className="space-y-2">
                {blogLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
                {col3.map((cat) => (
                  <li key={cat.name}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-10 pt-6 border-t border-background-100">
            <div className="flex items-center gap-4 text-xs text-foreground-500 whitespace-nowrap">
              <span>&copy; 2026 mulebuyspreadsheets.living</span>
              <span className="hidden sm:inline">|</span>
              <span>All rights reserved</span>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-shopping-bag-line text-white text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}